import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {LanguageListStore} from '../LanguageListStore';

@observer
export class EditLanguageControls extends React.Component<{ store: LanguageListStore }> {
  render() {
    const {store} = this.props;

    if (store.editLanguage === null)
      return null;

    const editLanguage = store.editLanguage;
    const isPending = editLanguage.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeEdit}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={editLanguage.save} align="right"/>
    </>);
  }
}
